import { render } from "./qonunlar.vue?vue&type=template&id=01fc1b58"
import script from "./qonunlar.vue?vue&type=script&lang=js"
export * from "./qonunlar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xurshid\\PROJECTS\\fvvga\\sayt\\vue_asosiy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__